import { render, staticRenderFns } from "./CryptoAdminListCryptos.vue?vue&type=template&id=6a1ca978&scoped=true"
import script from "./CryptoAdminListCryptos.vue?vue&type=script&lang=js"
export * from "./CryptoAdminListCryptos.vue?vue&type=script&lang=js"
import style0 from "./CryptoAdminListCryptos.vue?vue&type=style&index=0&id=6a1ca978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ca978",
  null
  
)

export default component.exports